import axios from "axios";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Config } from "../../../../../../Config";
import Switch from "../../../ShareElements/TextInput/Switch";

const EditNotifications = (props) => {
  const [OnlineConfigs, setOnlineConfigs] = useState();
  const [EmailConfigs, setEmailConfigs] = useState();
  const [HasMadeChanges, setHasMadeChanges] = useState(false);

  useEffect(() => {
    fetchNotificationConfigs();
  }, []);

  useEffect(() => {
    setOnlineConfigs(undefined);
    setEmailConfigs(undefined);
    setHasMadeChanges(false);
    fetchNotificationConfigs();
  }, [props.CancelConfirmed]);

  const translateText = (LabelId) => {
    var Filter = "label_id";
    var Keyword = LabelId;
    var Label = props.LangData.filter((Obj) => {
      return Obj[Filter] === Keyword;
    });
    return Label[0].label_value;
  };

  // API swagger Link:
  // https://dev-apigateway.connexing.io/notification-service/swagger-ui/index.html#/notification-config-controller/findAllConfigsUsingGET
  const fetchNotificationConfigs = () => {
    let Req = {
      method: "GET",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/config/find-all-configs",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
      },
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        sortOnlineConfigs(Res.data.details);
        sortEmailConfigs(Res.data.details);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const sortOnlineConfigs = (Data) => {
    let SortedArray = [];

    for (let i = 0; i < Data.length; i++) {
      if (i === 0) {
        Data.map((Item) => {
          if (Item.category === "AI_OFFLINE_JOB") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 1) {
        Data.map((Item) => {
          if (Item.category === "AI_OFFLINE_PROJECT") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 2) {
        Data.map((Item) => {
          if (Item.category === "AI_OFFLINE_ACTIVITY") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 3) {
        Data.map((Item) => {
          if (Item.category === "MY_APP_STATUS_IS_CHANGED") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 4) {
        Data.map((Item) => {
          if (Item.category === "MY_APP_STATUS_IS_ACCEPTED") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 5) {
        Data.map((Item) => {
          if (Item.category === "MY_CANDIDATE_IS_CHANGED_APP_STATUS") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 6) {
        Data.map((Item) => {
          if (Item.category === "CANDIDATE_APPLICATION") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 7) {
        Data.map((Item) => {
          if (Item.category === "AI_ONLINE_JPA") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 8) {
        Data.map((Item) => {
          if (Item.category === "ICP") {
            SortedArray.push(Item);
          }
        });
      }
    }
    setOnlineConfigs(SortedArray);
  };

  const sortEmailConfigs = (Data) => {
    let SortedArray = [];
    for (let i = 0; i < Data.length; i++) {
      if (i === 0) {
        Data.map((Item) => {
          if (Item.category === "PERSONALIZED_EXT_1") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 1) {
        Data.map((Item) => {
          if (Item.category === "MY_APP_STATUS_IS_ACCEPTED_EXT") {
            SortedArray.push(Item);
          }
        });
      } else if (i === 2) {
        Data.map((Item) => {
          if (Item.category === "PERSONALIZED_EXT_2") {
            SortedArray.push(Item);
          }
        });
      }
    }
    setEmailConfigs(SortedArray);
  };

  const displayOnlineCategoryTitle = (Category) => {
    switch (Category) {
      case "AI_OFFLINE_JOB":
        return translateText("new_job_recommendations");
      case "AI_OFFLINE_PROJECT":
        return translateText("new_project_recommendations");
      case "AI_OFFLINE_ACTIVITY":
        return translateText("new_activity_recommendations");
      case "AI_ONLINE_JPA":
        return translateText("new_recommended_candidates");
      case "ICP":
        return translateText("new_online_message");
      case "MY_APP_STATUS_IS_CHANGED":
        return translateText("status_update_of_my_application");
      case "MY_APP_STATUS_IS_ACCEPTED":
        return translateText("my_application_was_accepted");
      case "MY_CANDIDATE_IS_CHANGED_APP_STATUS":
        return translateText("status_change_by_candidates");
      case "CANDIDATE_APPLICATION":
        return translateText("new_applications");
    }
  };

  const displayEmailCategoryTitle = (Category) => {
    switch (Category) {
      case "PERSONALIZED_EXT_1":
        return translateText("personalized_recoms_and_status_update");
      case "MY_APP_STATUS_IS_ACCEPTED_EXT":
        return translateText("my_application_was_accepted");
      case "PERSONALIZED_EXT_2":
        return translateText("candidates_application_status_and_new_recoms");
    }
  };

  // Link to Swagger page:
  // https://dev-apigateway.connexing.io/notification-service/swagger-ui/index.html#/notification-config-controller/saveUsingPOST
  const toggleSave = () => {
    let Data = {
      details: [],
    };
    OnlineConfigs.concat(EmailConfigs).map((ConfItem) => {
      let Configuration = {
        enableEmailNotif: true,
        enableOnlineNotif: true,
        id: ConfItem.id,
      };
      // setting enableOnlineNotif based on its switch classList, if it contains off then it's false
      if (
        document.getElementById(ConfItem.id + "-online-switch-holder") !==
          null &&
        document
          .getElementById(ConfItem.id + "-online-switch-holder")
          .classList.contains("off")
      ) {
        Configuration.enableOnlineNotif = false;
      } else {
        Configuration.enableOnlineNotif = true;
      }
      // setting enableEmailNotif based on its switch classList, if it contains off then it's false
      if (
        document // doesn't exist in ICP category
          .getElementById(ConfItem.id + "-email-switch-holder") !== null &&
        document
          .getElementById(ConfItem.id + "-email-switch-holder")
          .classList.contains("off")
      ) {
        Configuration.enableEmailNotif = false;
      } else {
        Configuration.enableEmailNotif = true;
      }
      Data.details.push(Configuration);
    });
    // API request to save configurations with the generated data
    let Req = {
      method: "POST",
      baseURL:
        window._env_.API_URL +
        Config.NotificationService +
        "/api/notification/config/save",
      headers: {
        Authorization: "Bearer " + window.localStorage.getItem("Token"),
        "Content-Type": "application/json",
      },
      data: Data,
    };
    axios(Req)
      .then((Res) => {
        console.log(Res);
        window.localStorage.setItem("HasUnsaveChanges", "0");
        props.SetHasUnsavedChanges(false);

        if (props.SaveAndLeaveIsOn) {
          props.NavigateToSelectedTabAfterSave();
          props.SetSaveAndLeaveIsOn(false);
        }
        setHasMadeChanges(false);
      })
      .catch((Err) => {
        console.log(Err);
      });
  };

  const inputsChangeActions = () => {
    window.localStorage.setItem("HasUnsaveChanges", 1); // 1 means true, 0 means false
    setHasMadeChanges(true);
    props.SetHasUnsavedChanges(true);
  };

  const handleBackButtonAction = () => {
    props.SetWillReturnToHomePage(true);
    if (props.HasUnsavedChanges) {
      props.DisplayUnsavedChangesModal(true);
    } else {
      document.getElementById("link-to-home").click();
    }
  };

  const handleCancel = () => {
    props.SetModalTypeIsCancel(true);
    props.SetHasUnsavedChanges(false);
    if (props.HasUnsavedChanges) {
      props.DisplayUnsavedChangesModal(true);
    }
  };

  return (
    <div className="bg-column">
      <section className="bg-colum-head">
        <i
          className="feather-arrow-left"
          onClick={() => handleBackButtonAction()}
        ></i>
        <NavLink to="/" id="link-to-home"></NavLink>
        <h1>{translateText("notification_settings")}</h1>
        <div className="head-actions">
          <span
            className={
              HasMadeChanges
                ? "head-action-btn secondary-action"
                : "head-action-btn secondary-action disabled"
            }
            onClick={() => handleCancel()}
          >
            {translateText("cancel")}
          </span>
          <span
            className={
              HasMadeChanges
                ? "head-action-btn primary-action"
                : "head-action-btn primary-action disabled"
            }
            onClick={() => toggleSave()}
            id="save-btn"
          >
            {translateText("save")}
          </span>
        </div>
      </section>
      <div className="bg-form-body">
        <div className="notif-settings-rows">
          {OnlineConfigs === undefined ? null : (
            <React.Fragment>
              <h1 className="config-row-label">
                {translateText("online_notification_settings")}
              </h1>
              {OnlineConfigs.map((ConfigItem) => (
                <section className="notifs-config-row" key={ConfigItem.id}>
                  <p className="config-row-title">
                    {displayOnlineCategoryTitle(ConfigItem.category)}
                  </p>
                  <div className="online-switch">
                    <Switch
                      Id={ConfigItem.id + "-online"}
                      ChangeEvent={() => inputsChangeActions()}
                      IsActive={ConfigItem.enableOnlineNotif}
                    />
                  </div>
                </section>
              ))}
            </React.Fragment>
          )}
        </div>
        <div className="notif-settings-rows">
          {EmailConfigs === undefined ? null : (
            <React.Fragment>
              <h1 className="config-row-label">
                {translateText("email_notif_settings")}
              </h1>
              {EmailConfigs.map((ConfigItem) => (
                <section className="notifs-config-row" key={ConfigItem.id}>
                  <p className="config-row-title">
                    {displayEmailCategoryTitle(ConfigItem.category)}
                  </p>
                  <div className="email-switch">
                    <Switch
                      Id={ConfigItem.id + "-email"}
                      ChangeEvent={() => inputsChangeActions()}
                      IsActive={ConfigItem.enableEmailNotif}
                    />
                  </div>
                </section>
              ))}
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default EditNotifications;
